import { getClient } from '../api';
import { Company } from '../dtos';

export const API_COMPANIES_PATH = '/api/v1/companies';

export async function getCompany(idOrVat: string | number): Promise<Company> {
  const client = await getClient();
  const { data } = await client.get<Company>(`${API_COMPANIES_PATH}/${idOrVat}`);
  return data;
}

export async function createCompany(company: Company): Promise<Company> {
  const client = await getClient();
  const { data } = await client.post<Company>(API_COMPANIES_PATH, company);
  return data;
}

export async function updateCompany(id: number, company: Company): Promise<Company> {
  const client = await getClient();
  const { data } = await client.put<Company>(`${API_COMPANIES_PATH}/${id}`, company);
  return data;
}
